import { render, staticRenderFns } from "./SiteHeaderChat.vue?vue&type=template&id=5ddb14c7&scoped=true"
import script from "./SiteHeaderChat.vue?vue&type=script&lang=js"
export * from "./SiteHeaderChat.vue?vue&type=script&lang=js"
import style0 from "./SiteHeaderChat.vue?vue&type=style&index=0&id=5ddb14c7&prod&lang=scss"
import style1 from "./SiteHeaderChat.vue?vue&type=style&index=1&id=5ddb14c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb14c7",
  null
  
)

export default component.exports